import Div from 'src/components/atomic/atom/Div'
import Span from 'src/components/atomic/atom/Span'
import Input from 'src/components/atomic/atom/Input'
import Button from 'src/components/atomic/atom/Button'
import { COLOR } from 'src/constants/colors'
import { useTranslation } from 'react-i18next'
import { RootState } from 'src/store/store'
import { useEffect, useState } from 'react'
import { ColorHandler, InputBorderHandler } from 'src/utils/style.utils'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'

import { Cmdtypes } from 'src/constants/cmdtypes'
import { setDeleteDataInputValue, setCloseModal } from 'src/store/Reducer/common/modalSlice'
import Spinner from 'src/components/atomic/atom/Spinner'
import { SocketSender } from 'src/api/socket'

const DeleteDataModal = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { deleteDataInputValue } = useAppSelector((state: RootState) => state.modal)
  const [textValidCheck, setTextValidCheck] = useState<'default' | 'error' | 'success'>('default')
  const TextLengthValid = deleteDataInputValue?.length === 6
  const [deleteStatus, setDeleteStatus] = useState<'default' | 'loading'>('default')
  const { isOpen } = useAppSelector((state: RootState) => state.modal)

  useEffect(() => {
    return () => {
      setTextValidCheck('default')
      dispatch(setDeleteDataInputValue(''))
    }
  }, [isOpen, dispatch])

  const onBlurHandler = () => {
    TextLengthValid ? setTextValidCheck('success') : setTextValidCheck('default')
  }
  const textValidConfirmHandler = () => {
    if ('delete' === deleteDataInputValue) {
      dispatch(SocketSender(Cmdtypes.EXPLORER_DATA_DELETE))
      setDeleteStatus('loading')
    } else setTextValidCheck('error')
  }

  const loadingCancelButtonHandler = () => {
    dispatch(setCloseModal())
  }

  return (
    <>
      <Span option={'medium_bold'}>
        {t('MODAL.DELETE_DATA.TITLE', { defaultValue: 'Delete Data' })}
      </Span>
      {deleteStatus === 'default' ? (
        <>
          <Span option={'tiny'} $margin={'24px 0'}>
            {t('MODAL.DELETE_DATA.DESC', {
              defaultValue: 'Enter “delete” to confirm deletion of your data.',
            })}
          </Span>
          <Input
            autoFocus={true}
            option={'deleteData_modal'}
            value={deleteDataInputValue}
            onBlur={onBlurHandler}
            $border={InputBorderHandler(textValidCheck === 'success', textValidCheck === 'error')}
          />
          {textValidCheck === 'error' && (
            <Span option={'tiny'} $text_align={'left'} color={COLOR.red80} $margin={'12px 0 0 0'}>
              {t('MODAL.ENTER.CORRECT_STRING', { defaultValue: 'Enter Correct String' })}
            </Span>
          )}
          <Div
            display={'flex'}
            $margin={'24px auto 0 auto'}
            $gap={'16px'}
            $justify_content={'center'}
          >
            <Button
              option={'modal_cancel'}
              $margin={'0'}
              onClick={() => dispatch(setCloseModal())}
              $border={`1px solid ${COLOR.brand};`}
            >
              <Span color={COLOR.brand} option={'small_bold'}>
                {t('BUTTON.CANCEL', { defaultValue: 'Cancel' })}
              </Span>
            </Button>
            <Button
              option={'modal_ok'}
              $margin={'0'}
              disabled={!TextLengthValid}
              $bgColor={ColorHandler(TextLengthValid, 'brand_black10')}
              onClick={textValidConfirmHandler}
            >
              <Span option={'small_bold'} color={ColorHandler(TextLengthValid, 'white_black30')}>
                {t('BUTTON.OK', { defaultValue: 'OK' })}
              </Span>
            </Button>
          </Div>
        </>
      ) : (
        <>
          <Div
            $padding={'16px'}
            $bgColor={COLOR.black2}
            $border_radius={'12px'}
            $margin={'16px auto'}
          >
            <Div height={'24px'} $margin={'0 0 10px 0'}>
              <Spinner $height={'unset'} />
            </Div>
            <Span option={'tiny'}>Loading...</Span>
          </Div>
          <Button
            option={'modal_cancel'}
            $margin={'0'}
            onClick={loadingCancelButtonHandler}
            $border={`1px solid ${COLOR.brand};`}
          >
            <Span color={COLOR.brand} option={'small_bold'}>
              Close
            </Span>
          </Button>
        </>
      )}
    </>
  )
}
export default DeleteDataModal
